import { FormControl, Validators } from '@angular/forms';
import { QuotationDeliverable } from '@teem/models/quotation-deliverable';

export class QuotationDeliverableForm {
	uuid = new FormControl();
	title = new FormControl('', [Validators.required]);
	quantity = new FormControl(0, [Validators.required, Validators.min(1)]);
	rate = new FormControl(0, [Validators.required, Validators.min(0.01)]);
	is_taxable = new FormControl(true);
	edit: boolean = false;
	submitted: boolean = false;

	constructor(deliverable: QuotationDeliverable) {
		if (deliverable.uuid)
			this.uuid.setValue(deliverable.uuid);

		this.title.setValue(deliverable.title);
		this.quantity.setValue(deliverable.quantity);
		this.rate.setValue(deliverable.rate);
		this.is_taxable.setValue(!!deliverable.is_taxable);
	}

	get cost() {
		return this.quantity.value * this.rate.value;
	}
}
